import { clsx } from 'clsx';
import { FC, InputHTMLAttributes } from 'react';

import { getInputAria } from './Input.helpers';
import { InputBaseSelect } from './Input.type';
import { FieldWrapper } from './atoms/FieldWrapper';

type Props = Prettify<InputBaseSelect<string | number> & Omit<InputHTMLAttributes<HTMLSelectElement>, 'size'>>;

export const InputSelect: FC<Props> = ({
  className,
  placeholder,
  allowEmpty,
  labelOutside,
  subLabel,
  options,
  size,
  defaultValue,
  value,
  onChange,
  ...props
}) => {
  return (
    <FieldWrapper
      {...props}
      size={size}
      className={clsx(className, 'selectWrapper')}
      labelOutside={labelOutside}
      subLabel={subLabel}
    >
      <select
        {...props}
        {...getInputAria(props)}
        value={value ?? defaultValue}
        onChange={onChange}
        data-testid={props['data-testid']}
      >
        {placeholder && <option hidden>{placeholder}</option>}
        {allowEmpty && (
          <option aria-label="None" value="">
            {typeof allowEmpty === 'string' ? allowEmpty : null}
          </option>
        )}
        {Array.isArray(options)
          ? options.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))
          : Object.entries(options).map(([key, value]) => (
              <optgroup label={key} key={key}>
                {value.map((option) => (
                  <option value={option.value} key={option.value}>
                    {option.label}
                  </option>
                ))}
              </optgroup>
            ))}
      </select>
    </FieldWrapper>
  );
};
